module.exports = __webpack_public_path__ + "img/animal_placeholder.b3b5f702.png";